import { Button, Popover, NotificationBell } from '@beeline.com/bp-design-system';
import { MixpanelEvents } from 'integrations/mixpanel/Events/MixpanelEvents';
import { useMixpanel } from 'integrations/mixpanel/useMixpanel';
import React, { FC, useCallback, useState } from 'react';
import ErrorComponent from '../../../common/error/Error';
import { StyledListContainer, StyledListWrapper } from '../StyledHeaderComponents';
import { useNotificationsIntl } from '../translations/useNotificationsIntl';
import { useNotificationMapper } from './hooks/useNotificationMapper';
import { useNotificationMapperV2 } from './hooks/useNotificationMapperV2';
import { NotificationList } from './NotificationList';
export const Notifications: FC<{
  v2Mappings?: boolean;
}> = ({ v2Mappings }) => {
  const mapperV1 = useNotificationMapper();
  const mapperV2 = useNotificationMapperV2();
  const {
    markNotificationsAsRead,
    loadMore,
    loading,
    error,
    isFullyLoaded,
    unReadCount,
    refetchNotifications,
    notifications
  } = v2Mappings ? mapperV2 : mapperV1;
  const [bellEl, setBellEll] = useState<HTMLElement | undefined>(undefined);
  const handleClose = useCallback(() => setBellEll(undefined), []);
  const intl = useNotificationsIntl();
  const { track } = useMixpanel();
  return (
    <StyledListWrapper data-test="notif-button">
      <NotificationBell
        tooltipText="Notifications"
        unReadCount={unReadCount}
        onClick={(e) => {
          setBellEll(e.currentTarget);
          track(MixpanelEvents.notification.CLICK_NOTIFICATION_BELL);
        }}
        bellColor="colorOnBanner"
        dataTest="bell__icon"
      />
      <Popover
        open={!!bellEl}
        anchorEl={bellEl}
        onClose={handleClose}
        PaperProps={{ elevation: 8, square: false, style: undefined }}
      >
        {error ? (
          <ErrorComponent apolloError={error} onRetry={refetchNotifications} />
        ) : (
          <StyledListContainer>
            <NotificationList
              source="notifications"
              handleClose={handleClose}
              notifications={notifications}
              unReadCount={unReadCount}
              title="Notifications"
              markNotificationsAsRead={markNotificationsAsRead}
            />
            {!isFullyLoaded && notifications?.length ? (
              <Button fullWidth variant="text" onClick={loadMore} disabled={loading}>
                {intl.loadMore}
              </Button>
            ) : undefined}
          </StyledListContainer>
        )}
      </Popover>
    </StyledListWrapper>
  );
};
